var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navigation'),_c('v-main',[_c('confirm-modal',{ref:"confirm"}),_c('alert-modal',{ref:"alert"}),_c('snackbar',{ref:"snackbar"}),_c('Notifications',{ref:"notifications"}),_c('router-view'),_c('social-footer'),_c('cookie-banner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }